// Centralized query key factory
// All TanStack Query keys go here to ensure consistent cache sharing across hooks

export const queryKeys = {
  user: {
    role: (userId: string) => ['user-role', userId] as const,
    permissions: (userId: string) => ['user-permissions', userId] as const,
    profile: (userId: string) => ['user-profile', userId] as const,
    onboarding: (userId: string) => ['user-onboarding', userId] as const,
    subscription: (userId: string) => ['user-subscription', userId] as const,
  },
  subscription: {
    plans: () => ['subscription-plans'] as const,
    resourceTypes: () => ['subscription-resource-types'] as const,
    addonPacks: () => ['subscription-addon-packs'] as const,
    orgSubscription: (orgId: string) => ['org-subscription', orgId] as const,
    summary: (subscriptionId: string) => ['subscription-summary', subscriptionId] as const,
  },
};
